import BorderColorIcon from '@mui/icons-material/BorderColor';
import { CardActionArea, Divider } from '@mui/material';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../colors';
import { Lock } from '@mui/icons-material';

const SelectableCard = ({
  title,
  infoRows,
  onClickHandler,
  showEditIcon = true,
  borderColor = Colors.green
}) => {
  const CardStyled = styled(CardActionArea)(({ theme }) => ({
    minHeight: '60px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    border: `1px solid ${borderColor}`,
    borderRadius: '10px',
    padding: '10px',
    position: 'relative'
}));

  return (
    <div>
      <h3>
        {title}
      </h3>
      <CardStyled
        onClick={onClickHandler} >
        <Stack >
          {infoRows.map((row, index) => (
            <React.Fragment key={index}>
              {row}
              {index < infoRows.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Stack>
        {!showEditIcon && <Lock sx={{ 
          position: 'absolute', 
          top: 15, 
          right: 15, 
          color: `${Colors.red}` 
          }} />}
        {showEditIcon && <BorderColorIcon sx={{ 
          position: 'absolute', 
          bottom: 15, 
          right: 15, 
          color: `${Colors.mediumGray}` 
          }} />}
      </CardStyled>
    </div>
  );
};

export default SelectableCard;
